<template>
  <div>
    <div class="content">
      <!--      <div class="content-main">-->
      <!--        <p class="content-title">用户权限</p>-->
      <!--      </div>-->
      <div class="content-main">
        <p class="content-title" style="padding-bottom: 16px;">运营辅助</p>
        <el-button @click="changePhone">更换手机号</el-button>
        <el-button @click="clearSms">清除注册登录短信次数限制</el-button>
      </div>

    </div>
  </div>
</template>

<script>
import Dialog from "@/assets/js/dialog";
import ChangePhoneDialog from "@/views/setting/components/ChangePhoneDialog";
import clearSmsDialog from "@/views/setting/components/clearSmsDialog";

export default {
  name: "Auxiliary",
  data() {
    return {

    }
  },
  methods: {
    changePhone() {
      let _title = '更换手机号';
      Dialog.open({
        title: _title,
        component: ChangePhoneDialog,
        data: {
          width: '500px'
        },
        confirm: (result) => {
        }
      })
    },

    clearSms() {
      let _title = '清除注册登录短信次数限制';
      Dialog.open({
        title: _title,
        component: clearSmsDialog,
        data: {
          width: '500px'
        },
        confirm: (result) => {
        }
      })
    }

  },
  mounted() {

  }
}
</script>

<style scoped>
.el-table {
  --el-table-header-bg-color: #ffffff !important;
}
</style>
